import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getSiteWorkData = job => {
    let siteWorkList = []
    job.siteWorks.forEach(item => {
      siteWorkList.push(
        <div className="row">
          {item.customer_requested_start_date &&
            this.checkedDateListContains('Customer Requested Start') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Customer Requested Start</p>
                <p>{moment(item.customer_requested_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.estimated_start_date &&
            this.checkedDateListContains('Estimated Start') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Estimated Start</p>
                <p>{moment(item.estimated_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.confirmed_start_date &&
            this.checkedDateListContains('Confirmed Start') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Confirmed Start</p>
                <p>{moment(item.confirmed_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.estimated_adjusting_start_date &&
            this.checkedDateListContains('Estimated Adjusting') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Estimated Adjusting</p>
                <p>{moment(item.estimated_adjusting_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.confirmed_adjusting_start_date &&
            this.checkedDateListContains('Confirmed Adjusting') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Confirmed Adjusting</p>
                <p>{moment(item.confirmed_adjusting_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.bec_inspection_start_date &&
            this.checkedDateListContains('BEC Inspection') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">BEC Inspection</p>
                <p>{moment(item.bec_inspection_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.final_inspection_start_date &&
            this.checkedDateListContains('Final Inspection') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Final Inspection</p>
                <p>{moment(item.final_inspection_start_date).format('YYYY-MM-DD')}</p>
              </div>
            )}
          {item.temporary_construction_use_inspection_start_date &&
            this.checkedDateListContains('Temporary Construction Use Inspection') && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">
                  Temporary Construction Use Inspection
                </p>
                <p>
                  {moment(item.temporary_construction_use_inspection_start_date).format(
                    'YYYY-MM-DD'
                  )}
                </p>
              </div>
            )}
        </div>
      )
    })
    return siteWorkList
  }

  checkedDateListContains = text => {
    const { checkedDateList } = this.props
    if (checkedDateList.length == 0) {
      return true
    }
    return checkedDateList.indexOf(text) >= 0
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      if (item.siteWorks && item.siteWorks.length > 0) {
        jobList.push(
          <div>
            <h6 className="steps">{item.job_name}</h6>
            {this.getSiteWorkData(item)}
          </div>
        )
      }
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Site Work Schedules</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/site-work-schedule/ListItem.js